import { createRoot } from "react-dom/client";
import { flushSync } from "react-dom";
import { LegendBox, LEGEND_FONT_FAMILY, LEGEND_FONT_SIZE } from "../LegendBox";
import { LEGEND_TEXT_COLOR } from "../LegendBox/constants";
import type { RenderRoomSectionsSvgString } from "./types";

const TITLE_FONT_FACTOR = 1.6;
const NOTE_LINE_FACTOR = 1.6;
const NOTE_TEXT_COLOR = "#6B7280";

export const renderRoomSectionsSvgString: RenderRoomSectionsSvgString = ({
  pdfPageWidth,
  pdfPageHeight,
  pixelWidth,
  pixelHeight,
  scale,
  header,
  placedLegends,
}) => {
  const titleFontSize = LEGEND_FONT_SIZE * TITLE_FONT_FACTOR * scale;
  const noteFontSize = LEGEND_FONT_SIZE * scale;
  const titleBaselineY = header.y + titleFontSize;
  const noteBaselineY = titleBaselineY + noteFontSize * NOTE_LINE_FACTOR;

  const detachedContainer = document.createElement("div");
  const root = createRoot(detachedContainer);

  try {
    flushSync(() => {
      root.render(
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox={`0 0 ${pdfPageWidth} ${pdfPageHeight}`}
          width={pixelWidth}
          height={pixelHeight}
        >
          <text
            x={header.x}
            y={titleBaselineY}
            fontFamily={LEGEND_FONT_FAMILY}
            fontSize={titleFontSize}
            fontWeight={600}
            fill={LEGEND_TEXT_COLOR}
          >
            {header.title}
          </text>
          <text
            x={header.x}
            y={noteBaselineY}
            fontFamily={LEGEND_FONT_FAMILY}
            fontSize={noteFontSize}
            fill={NOTE_TEXT_COLOR}
          >
            {header.note}
          </text>
          {placedLegends.map((placed, index) => (
            <LegendBox
              key={`${placed.legend.summary.left}-${index}`}
              x={placed.x}
              y={placed.y}
              items={placed.legend.items}
              summary={placed.legend.summary}
              scale={scale}
            />
          ))}
        </svg>,
      );
    });

    const svgElement = detachedContainer.querySelector("svg");
    if (!svgElement) {
      throw new Error("SVG element not found in room sections render output");
    }

    return new XMLSerializer().serializeToString(svgElement);
  } finally {
    root.unmount();
  }
};
